import React from 'react';
import { Layout } from 'fronton-react';
import { COMMON_LANDINGS_IMAGES_CDN_PATH } from 'common/constants/common';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { Typography } from '../typography';
import {
  creditSection,
  creditSectionContent,
  creditSectionImgFirst,
  creditSectionImgSecond,
  creditSectionImgWrapper,
  creditSectionText,
  creditSectionTitle,
  creditSectionWrapper,
} from './credit-block-styles';

export const CreditBlock: React.FC = () => (
  <Section className={creditSection}>
    <Layout>
      <div className={creditSectionWrapper}>
        <div className={creditSectionContent}>
          <SectionSubTitle className={creditSectionTitle} margin="s">
            Покупайте сейчас&nbsp;&mdash; платите потом
          </SectionSubTitle>
          <Typography className={creditSectionText} variant="l" size="body_long">
            Кредит без переплат на&nbsp;весь период
          </Typography>
        </div>
        <div className={creditSectionImgWrapper}>
          <picture>
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/1-ld.png/1-ld.png`}
              media={strictBreakpoints['--only-largeDesktop']}
            />
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/1-d.png/1-d.png`}
              media={strictBreakpoints['--only-desktop']}
            />
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/1-t.png/1-t.png`}
              media={strictBreakpoints['--only-tablet']}
            />
            <img
              className={creditSectionImgFirst}
              alt="0% первый взнос"
              title="0% первый взнос"
              src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/1-m.png/1-m.png`}
              width="232"
              height="99"
            />
          </picture>
          <picture>
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/2-ld.png/2-ld.png`}
              media={strictBreakpoints['--only-largeDesktop']}
            />
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/2-d.png/2-d.png`}
              media={strictBreakpoints['--only-desktop']}
            />
            <source
              srcSet={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/2-t.png/2-t.png`}
              media={strictBreakpoints['--only-tablet']}
            />
            <img
              className={creditSectionImgSecond}
              alt="Кредит 6-10 месяцев"
              title="Кредит 6-10 месяцев"
              src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/2-m.png/2-m.png`}
              width="354"
              height="99"
            />
          </picture>
        </div>
      </div>
    </Layout>
  </Section>
);
